import React, { useEffect, useRef, useState } from "react";
import "../styles/Collaborations.css";
import { FaGlobe, FaFileAlt, FaHandshake } from "react-icons/fa";
import CollaborateImage from "../images/colalboration.png"; // Replace with your image

const Collaborations = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // Intersection Observer for detecting visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const collaborations = [
    {
      icon: <FaGlobe />,
      title: "Online Platform",
      description:
        "Explore our Moodle-based LMS for a user-friendly and interactive educational experience.",
    },
    {
      icon: <FaFileAlt />,
      title: "Curated Content",
      description:
        "Access meticulously curated lesson plans, activity sheets, and best practices for Islamic pedagogy.",
    },
    {
      icon: <FaHandshake />,
      title: "Collaborative Initiatives",
      description:
        "Engage in partnerships for developing innovative teaching methods and advancing Islamic education globally.",
    },
  ];

  return (
    <section className="collaborations-section" ref={sectionRef}>
      <div className="collaborations-container">
        <h2 className="collaborations-heading">Collaborating for Excellence</h2>
        <p className="collaborations-subheading">
          Join hands with Qibla to inspire, empower, and educate through a shared commitment to
          knowledge and values.
        </p>

        <div className="timeline">
          {collaborations.map((item, index) => (
            <div
              key={index}
              className={`timeline-item ${isVisible ? "fade-in" : ""}`}
            >
              <div className="timeline-icon">{item.icon}</div>
              <div className="timeline-content">
                <h3 className="timeline-title">{item.title}</h3>
                <p className="timeline-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {isVisible && (
        <img
          src={CollaborateImage}
          alt="Decorative Image"
          className="collaborate-decoration"
        />
      )}
    </section>
  );
};

export default Collaborations;
